import { graphql } from 'gql';

export const parsedEstimateBasisGql = graphql(`
    query uerParsedEstimateBasis(
        $contractId: Long!
        $fileContent: FileInput!
        $chapter: ChapterEnum!
        $uerClassifier: UerClassifierEnum
    ) {
        uerParsedEstimateBasis(
            contractId: $contractId
            fileContent: $fileContent
            chapter: $chapter
            uerClassifier: $uerClassifier
        ) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
            data {
                version
                section
                group
                code
                name
                unit
                chapter
                basePrice {
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    nr
                    sp
                    unitCost
                }
                currentPrices {
                    unitCost
                    unitCostWithOther
                    constructionTypeId
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    nr
                    sp
                }
                workScopes {
                    number
                    description
                }
            }
        }
    }
`);

export const addUerToWorkOrder = graphql(`
    mutation uerAddUerToWorkOrder($workOrderObjectId: Long!, $priceListUerRowInput: PriceListUerRowCreateInput!) {
        uerAddUerToWorkOrder(workOrderObjectId: $workOrderObjectId, priceListUerRowInput: $priceListUerRowInput) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const createUerRowGql = graphql(`
    mutation uerCreateUerRow($input: PriceListUerRowCreateInput!) {
        uerCreateUerRow(input: $input) {
            data {
                id
                code
                name
                unit
                chapter
                uerClassifier
                status
                sectionId
                sectionName
                groupId
                groupCode
                groupName
                justification
                basePrice {
                    ozp
                    emm
                    eqp
                    mtr
                    nr
                    pir
                    sp
                    trn
                    zpm
                    unitCost
                }
                currentPrices {
                    id
                    constructionTypeId
                    constructionTypeName
                    unitCost
                    unitCostWithOther
                    ozp
                    emm
                    eqp
                    mtr
                    nr
                    pir
                    sp
                    trn
                    zpm
                }
                workScopes {
                    number
                    description
                }
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateUerPriceListRow = graphql(`
    mutation uerUpdateUerRow($input: PriceListUerRowUpdateInput!) {
        uerUpdateUerRow(input: $input) {
            data {
                code
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const priceListUerRowWithRatioGql = graphql(`
    query uerPriceListUerRowWithRatio($uerBaseRowId: Long!) {
        uerPriceListUerRowWithRatio(uerBaseRowId: $uerBaseRowId) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
            data {
                id
                version
                code
                name
                unit
                chapter
                uerClassifier
                status
                sectionId
                sectionName
                groupId
                groupCode
                groupName
                justification
                basePrice {
                    ozp
                    emm
                    eqp
                    mtr
                    nr
                    pir
                    sp
                    trn
                    zpm
                    unitCost
                }
                constructionTypes {
                    id
                    name
                    shortName
                    code
                    isUsedLink
                }
                currentPrices {
                    id
                    constructionTypeId
                    constructionTypeName
                    constructionTypeRelationStatus
                    unitCost
                    unitCostWithOther
                    ozp
                    emm
                    eqp
                    mtr
                    nr
                    pir
                    sp
                    trn
                    zpm
                }
                workScopes {
                    number
                    description
                }
                ratioItems {
                    rationId
                    name
                    code
                    isUsedLink
                }
                ratioGroups {
                    groupId
                    name
                }
                sectionIsArtificial
                workKind {
                    workCode
                    workInSum
                    workName
                    workRatio
                    workUniqueId
                    workUnit
                }
            }
        }
    }
`);

export const updateUerToWorkOrderFromPriceListGql = graphql(`
    mutation uerUpdateUerToWorkOrderFromPriceList($input: PriceListUerRowUpdateInput!, $workOrderPriceId: Long!) {
        uerUpdateUerToWorkOrderFromPriceList(input: $input, workOrderPriceId: $workOrderPriceId) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const currentEstimateBasisGql = graphql(`
    query uerCurrentEstimateBasis($chapter: ChapterEnum!, $uerBaseRowId: Long!) {
        uerCurrentEstimateBasis(chapter: $chapter, uerBaseRowId: $uerBaseRowId) {
            data {
                chapter
                section
                group
                code
                name
                unit
                basePrice {
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    nr
                    sp
                    unitCost
                }
                currentPrices {
                    constructionTypeId
                    unitCost
                    unitCostWithOther
                    sp
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    nr
                }
                workScopes {
                    number
                    description
                }
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
